import { useEffect, FC, PropsWithChildren } from 'react'
import { useTrackVisibility } from 'react-intersection-observer-hook'

type TrackVisibilityProps = {
  onChange: (isVisible: boolean) => any
  options?: Parameters<typeof useTrackVisibility>[0]
}

const TrackVisibility: FC<PropsWithChildren<TrackVisibilityProps>> = ({
  onChange,
  options,
  children,
}) => {
  const [ref, { isVisible }] = useTrackVisibility(options)

  useEffect(() => {
    onChange(isVisible)
  }, [onChange, isVisible])

  return <div ref={ref}>{children}</div>
}

export default TrackVisibility
